import HeaderBack from "@/components/fragments/HeaderBack";
import RevenueReportBase from "./components/Base";

export default function RevenueReportFeature() {
  return (
    <div className="relative">
      <HeaderBack text="Laporan Pendapatan" url="/home" />
      <RevenueReportBase />
    </div>
  );
}
